import { createMemorySource, createHistory } from "@reach/router";
const source = createMemorySource("/map"); //list or map for default
export const history = createHistory(source);
export const navigate = history.navigate;